<template>
  <b-row>
    <b-col lg="12" class="px-5 py-2">
      <iq-card>
        <template v-slot:headerTitle>
          <h4 class="card-title text-primary"><strong>List Expired Medical Check Up</strong></h4>
        </template>
        <template v-slot:body>
          <b-row>
            <b-col md="12">
              <b-button
                v-if="list && list.data && list.data.length"
                variant="primary"
                class="mb-2"
                :disabled="exporting"
                @click="exportTable"
              >
                <span v-if="exporting" class="spinner-border spinner-border-sm mr-2"></span>
                <i v-else class="fa fa-file-excel mr-2"></i>
                Export
              </b-button>

              <div class="d-flex w-100 align-items-center justify-content-between mb-4">
                <b-form-input
                  v-model="searchQuery"
                  class="align-self-end w-50"
                  placeholder="Search name/NIP/document..."
                  @keyup.enter="onFilter"
                />
                <b-button variant="primary" @click.prevent="onFilter">
                  <i class="fa fa-filter"></i>
                </b-button>
              </div>
            </b-col>

            <b-col v-if="loading" md="12">
              <div class="alert alert-info m-4 align-items-center">
                <span class="spinner-border spinner-border-sm mr-2"></span> Loading...
              </div>
            </b-col>

            <b-col v-else md="12">
              <div v-if="list && list.data && list.data.length" class="d-flex overflow-auto">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">NO</th>
                      <th class="text-center">Name</th>
                      <th class="text-center">Document</th>
                      <th class="text-center">Place &amp; Date Issued</th>
                      <th class="text-center">Expired Date</th>
                      <th class="text-center">Notes</th>
                      <th class="text-center">File</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(mcu, index) in list.data" :key="mcu.id || index">
                      <td class="text-center">{{ (list.from || 1) + index }}</td>
                      <td>
                        <router-link
                          v-if="crewId(mcu)"
                          :to="{ path: 'profile', query: { user: 'crew', id: crewId(mcu) } }"
                        >{{ crew(mcu).fullname || '-' }}</router-link>
                        <span v-else>{{ crew(mcu).fullname || '-' }}</span><br />
                        <small class="text-muted">NIP : <b>{{ crew(mcu).nip || '-' }}</b></small>
                      </td>
                      <td class="text-center">{{ mcu.nama_document || mcu.document_name || '-' }}</td>
                      <td class="text-center">
                        {{ issuedAt(mcu) }}
                      </td>
                      <td class="text-center">{{ formatDate(mcu.date_expired || mcu.expired_date) }}</td>
                      <td class="text-center">{{ mcu.notes || mcu.remarks || '-' }}</td>
                      <td class="text-center">
                        <i
                          v-if="mcu.file_url"
                          class="fa fa-file-alt text-primary"
                          style="cursor: pointer"
                          @click="openFile(mcu.file_url)"
                        ></i>
                        <span v-else>-</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <b-pagination
                v-if="list && list.data && list.data.length"
                class="mt-3"
                :value="list.current_page"
                :total-rows="list.total"
                :per-page="list.per_page"
                first-number
                align="center"
                @change="getListExpiredMCU"
              />
              <p v-else class="text-center my-4">List Expired MCU tidak ada.</p>
            </b-col>
          </b-row>
        </template>
      </iq-card>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import { saveAs } from 'file-saver'
import { crewingActions } from '@src/Utils/helper'

export default {
  name: 'SlideListMCU',
  data () {
    return {
      list: null,
      loading: false,
      exporting: false,
      searchQuery: ''
    }
  },
  async mounted () {
    await this.getListExpiredMCU()
  },
  methods: {
    ...crewingActions,
    crew (mcu) {
      return mcu.emp_crewing || mcu.crew || {}
    },
    crewId (mcu) {
      return this.crew(mcu).id || mcu.emp_crewing_id
    },
    formatDate (date) {
      return date && date !== 'null' ? moment(date).format('DD MMMM YYYY') : '-'
    },
    issuedAt (mcu) {
      const place = mcu.place_issued || '-'
      const date = this.formatDate(mcu.date_issued || mcu.issued_date)
      return place === '-' && date === '-' ? '-' : `${place}, ${date}`
    },
    openFile (url) {
      window.open(url, '_blank')
    },
    async onFilter () {
      await this.getListExpiredMCU(1)
    },
    async getListExpiredMCU (page = 1) {
      try {
        this.loading = true
        const params = {
          page,
          per_page: 50
        }

        if (this.searchQuery) params.filter = this.searchQuery

        const response = await this.fetchExpiredMCUList(params)
        this.list = response.data
      } catch (error) {
        this.list = null
      } finally {
        this.loading = false
      }
    },
    async exportTable () {
      try {
        this.exporting = true
        const params = { export: true }
        if (this.searchQuery) params.filter = this.searchQuery

        const response = await this.fetchExpiredMCUList(params)
        if (response.status !== 'success') throw new Error('API gagal membuat file export')
        saveAs(response.data, 'Expired MCU.xlsx')
      } catch (error) {
        this.$swal('Oops!', 'Export Failed: ' + error, 'error')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>
